module.exports = __webpack_public_path__ + "media/discovery-ui/assets/social/facebook-white-53adf08e61f249d61ae3c4f7b5c375c7.svg";